import React from 'react';
import { CommunicationPreferencesProps } from './types';

const CommunicationPreferences: React.FC<CommunicationPreferencesProps> = ({
  preferences,
  onPreferenceChange,
  isEditing = false
}) => {
  return (
    <div className="mt-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        {isEditing ? 'Communication Preferences' : 'Keeping in touch'}
      </h2>

      {!isEditing && (
        <p className="text-gray-600 mb-4 text-sm md:text-base">
          We'd like to communicate with you about the things you care about.
          News that's important to you, updates that make your experiences even
          richer, and surveys to help us improve our service via emails, push
          notifications, and on-site messaging.
        </p>
      )}

      <div className="space-y-3">
        <label className="flex items-center space-x-3">
          <input
            type="checkbox"
            checked={preferences.emailOffers}
            onChange={() => onPreferenceChange('emailOffers')}
            disabled={!isEditing}
            className="form-checkbox h-5 w-5 md:h-6 md:w-6 text-blue-600"
          />
          <span className="text-gray-700 text-sm md:text-base">
            {isEditing
              ? "Yes, I'd like to receive emails about offers (Optional)"
              : "Yes please, I'd like to receive emails about offers and services (Optional)"}
          </span>
        </label>

        <label className="flex items-center space-x-3">
          <input
            type="checkbox"
            checked={preferences.pushNotifications}
            onChange={() => onPreferenceChange('pushNotifications')}
            disabled={!isEditing}
            className="form-checkbox h-5 w-5 md:h-6 md:w-6 text-blue-600"
          />
          <span className="text-gray-700 text-sm md:text-base">
            {isEditing
              ? "Yes, I'd like to receive notifications about offers (Optional)"
              : "Yes please, I'd like to receive notifications about offers and services (Optional)"}
          </span>
        </label>
      </div>
    </div>
  );
};

export default CommunicationPreferences;
